import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const CS_INFO_DOMAIN = "cs-info";
export const CS_INFO_DETAIL_ENDPOINT = "detail";

export interface CsInfoType {
  userId: number;
  email?: string;
  nickname?: string;
  coachName?: string;
  subscriptionStartDate?: string;
  subscriptionPayAmount?: number;
  subscriptionExpirationDate?: string;
  subscriptionStatus?: string;
  subscriptionCount?: number;
  plan?: string;
  hasBeenRefunded?: boolean;
}

export const csInfoApi = {
  getDetail: () =>
    axiosInstance.get<CustomResponseFormat<CsInfoType>>(
      `${CS_INFO_DOMAIN}/${CS_INFO_DETAIL_ENDPOINT}`
    ),
};
